
import api from '../api';
class CompanyUserService {
    async GetVacationSwapMarketplace(searchModel) {
        const loginSource = localStorage.getItem('loginSource');
        if (loginSource === 'Mobile') {
            searchModel.pageSize = 1000;
        }
        return await api.post('VacationSwapMarketplace/GetVacationSwapMarketplace', searchModel);
    }

    //async getVacationSwapMarketplaceEmailListing(searchModel) {
    //    return await api.post(`VacationSwapMarketplace/GetEmailVacationSwapMarketList`, searchModel);
    //}
    //async getVacationSwapMarketplaceSmsListing(searchModel) {
    //    return await api.post(`VacationSwapMarketplace/GetSmsVacationSwapMarketList`, searchModel);
    //}
  
    async GetAssetDetailsForVactionSwapMarketplace(assetId, userId, shareid, BookingId) {
        return await api.get(`ManageAsset/GetAssetDetailsForVactionSwapMarketplace/${assetId}/${userId}/${shareid}/${BookingId}`);
    }
    //async SendSmsSwapMarket(SmsModel) {
    //    return await api.post(`VacationSwapMarketplace/SendMultipleSMS`, SmsModel);
    //}
    //async SendEmailSwapMarket(emailModel) {
    //    return await api.post(`VacationSwapMarketplace/SaveEmailVacationSwapMarket`, emailModel);
    //}
    async GetVacationSwapRequestDetails(searchModel) {
        return await api.post(`VacationSwapMarketplace/GetVacationSwapRequestDetails`, searchModel);
    }
    async SaveVacationRequestDetails(emailModel) {
        return await api.post(`VacationSwapMarketplace/SaveVacationRequestDetails`, emailModel);
    }
    async getMonthlyContent(search, userid, companyid, pagesize) {
        return await api.get(`CompanyDashboard/GetMonthlyContentList/${search}/${userid}/${companyid}/${pagesize}`);
    }
    async getMonthlyContentDetail(id, userID) {
        return await api.get(`CompanyDashboard/GetMonthlyContentDetail/${id}/${userID}`);
    }
    async getManageCourse(search, userid, companyid, pagesize) {
        return await api.get(`CompanyDashboard/GetCourseList/${search}/${userid}/${companyid}/${pagesize}`);
    }
    async getCourseDetail(id, userID) {
        return await api.get(`CompanyDashboard/GetCourseDetail/${id}/${userID}`);
    }
    async getAssetPublishedListing(searchModel) {
        return await api.post(`ManageAsset/getAssetPublishedListing`, searchModel);
    }
    async GetPropertyReviewList(searchFields, sortColumn, sortDir, pageIndex, pageSize, userId, companyId) {
        if (typeof searchFields == "undefined" || searchFields == null || searchFields == "") { searchFields = "00Test"; }
        return await api.get(`ManageAsset/GetRequestPropertyReviewList/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${userId}/${companyId}` );
    }
    async IsApproveStatus(id, status) {
        return await api.get(`ManageAsset/IsApproveStatusById/${id}/${status}`)
    }
    async getMonthlyContentAmbassidorList(searchModel) {
        return await api.post(`CompanyDashboard/GetMonthlyContentCompanyList`, searchModel);
    }
    async SharetoallMontely(userId, sharetoall, CurrentSelectLanguage) {
        return await api.get(`MonthlyContent/ShareToAllMontlyContent/${userId}/${sharetoall}/${CurrentSelectLanguage}`)
    }
    async Deletemonthcontent(id, UserId, CompanyId, ipaddress, CurrentSelectLanguage) {
        return await api.get(`MonthlyContent/DeleteMonthlyContentById/${id}/${UserId}/${CompanyId}/${ipaddress}/${CurrentSelectLanguage}`);
    }
    async GetAmbassadorClientList(userId) {
        return await api.get(`ManageTestimonial/GetAmbassadorClientList/${userId}`);

    }
    async getmonthlycontentDatabyId(id) {
        return await api.get(`MonthlyContent/GetMonthlyContentById/${id}`);
    }
    async AddupdatemonthlycontentFrontend(monthlyContent) {
        return await api.post(`MonthlyContent/AddManageMonthlyContentFromCompany`, monthlyContent, {
            "Content-Type": "multipart/form-data"
        });
    }
    async GetAllFavouriteList(searchModel) {
        return api.post('ManageAsset/GetWishListAssets', searchModel);
    }
    async DeleteFavouriteById(id, userId, companyId, IPAddresss) {
        return api.get(`ManageAsset/DeleteAssetfromWishList/${id}/${userId}/${companyId}/${IPAddresss}`);
    }

    //async GetAmbassadorClientList(userId) {
    //    return await api.get(`ManageTestimonial/GetAmbassadorClientList/${userId}`);
    //}
    async SendShareLinkEmail(sendEmailModel) {
        return await api.post(`Newsletter/SendShareLinkEmail`, sendEmailModel);
    }
    async GetOwnedPropertList(SearchModel) {
        const loginSource = localStorage.getItem('loginSource');
        if (loginSource === 'Mobile') {
            SearchModel.pageSize = 1000;
        }
        return api.post('ManageAsset/GetPaymentListAssets', SearchModel);
    }
    async GetSwapPropertyRequestRecevicedList(searchModel) {
        return await api.post(`VacationSwapMarketplace/GetAssetRequestRecevicedList`, searchModel);
    }
    async MovetoMarketPlace(aspNetId, assetId, companyId, movetoMarketPlaceVal, shareId, BookingId) {
        return await api.get(`ManageAsset/MovetoMarketPlace/${aspNetId}/${assetId}/${companyId}/${movetoMarketPlaceVal}/${shareId}/${BookingId}`)
    }
    async GetAssetDetailsForBooking(model) {
        return await api.post(`ManageAsset/GetAssetDetailsForBookingProperty`, model);
    }
    async getMembershipDetail(userid) {
        return await api.get(`MemberShipsDetail/GetMembershipdetail/${userid}`);
    }
    async getMembershipPaymentHistory(search, userid, sortby, orderby, pageindex, pagesize) {
        return await api.get(`MemberShipsDetail/getmembershipdetail/${search}/${userid}/${sortby}/${orderby}/${pageindex}/${pagesize}`);
    }
    async PaySubscriptionDuePayment(makepayment) {
        return await api.post(`MemberShipsDetail/MakeMebershipPayment`, makepayment);
    }
    async downloadInvoice(companyid, userid, companylogo) {
        return await api.get(`manageCompany/DownloadUserInvoicePdf/${companyid}/${userid}/${companylogo}`, { responseType: 'blob' });
    }
    async getMembershipPaymentHistory(search, userid, sortby, orderby, pageindex, pagesize) {
        return await api.get(`MemberShipsDetail/getmembershipdetail/${search}/${userid}/${sortby}/${orderby}/${pageindex}/${pagesize}`);
    }
    async downloadExcel(records, filename, firstListHeader, secondListHeader) {
        return await api.post(`Common/ExportExcelForMemberShip/${filename}/${firstListHeader}/${secondListHeader}`, records, { responseType: 'blob' });
    }
    async SingledownloadInvoice(Id, companyid, userid, companylogo) {
        return await api.get(`manageCompany/DownloadSingleInvoicePdf/${Id}/${companyid}/${userid}/${companylogo}`, { responseType: 'blob' });
    }

    async GetPropertyScheduleMeetingList(searchFields, sortColumn, sortDir, pageIndex, pageSize, userId, companyId) {
        if (typeof searchFields == "undefined" || searchFields == null || searchFields == "") { searchFields = "00Test"; }
        return await api.get(`ManageAsset/GetRequestPropertyScheduleMeetingList/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${userId}/${companyId}`);
    }

    async getUserDetail(id, optional) {
        return await api.get(`UserProfile/GetUserDetailById/${id}/${optional}`);
    }
    async GetSocialMediaProfileDetails(userId, companyId) {
        return await api.get(`UserProfile/GetSocialMediaProfileById/${userId}/${companyId}`);
    }
    async SaveProfileFile(formData) {
        return await api.post(`UserProfile/SaveProfileFile`, formData, {
            "Content-Type": "multipart/form-data"
        });
    }
    async SaveSocialMediaProfileDetails(socialMediaModel) {
        return await api.post(`UserProfile/SaveSocialMediaProfileDetails`, socialMediaModel);
    }
    async updateUserProfile(userProfile) {
        debugger;
        return await api.post(`UserProfile/CompanyWebUpdateUser`, userProfile);
    }
    async setPassword(setPassword) {
        return await api.post(`Account/ResetPassword`, setPassword);
    }
    async gettoken(email) {
        return await api.get(`UserProfile/gettoken/${email}`);
    }
    async countryList(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    async getStateList() {
        return await api.get('UserList/GetStateList');
    }
    async AddEditContactUser(userModel) {
        return await api.post(`ManageContacts/AddEditContactUser`, userModel);
    }
    async GetAreaofInterestList(SearchModel) {
        debugger;
        return await api.post('AreaofInterest/GetAreaofInterestList', SearchModel);
    }
    async countryList(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    async getStateList() {
        return await api.get('UserList/GetStateList');
    }
    async GetEditAOI(id) {

        return await api.get(`AreaofInterest/EditAOIbyId/${id}`);
    }
    async AOFAddEdit(AOIModel) {
        return await api.post(`AreaofInterest/AddEditAreaofInterest`, AOIModel);
    }
    async DeleteAOI(id, userId, companyId, IPAddress) {
        return api.get(`AreaofInterest/DeleteAOI/${id}/${userId}/${companyId}/${IPAddress}`);
    }

    async GetPageSizeList() {
        let masterNames = 'PageSize';
        let masterKeyText = 'PageSize';
        let userId = localStorage.getItem('userId');
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    async GetAOIList(searchFields, status, sortColumn, sortDir, page, pageSize, userId, companyId) {
        if (typeof searchFields == "undefined" || searchFields == null || searchFields == "") { searchFields = "00Test"; }
        return await api.get(`AreaofInterest/GetAOIList/${searchFields}/${status}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);

    }
    async getManageArticle(search, userid, companyid, pagesize) {
        return await api.get(`CompanyDashboard/GetArticleList/${search}/${userid}/${companyid}/${pagesize}`);
    }
    async getArticleDataById(id, userID) {
        return await api.get(`CompanyDashboard/GetArticleDetail/${id}/${userID}`);
    }
    async AddBookProperty(BookPropertiesModel) {
        return await api.post(`ManageAsset/BookProperties`, BookPropertiesModel);
    }
    async GetTripChecklist(bookingId, companyId) {
        return await api.get(`TripChecklist/Portal/${bookingId}`, { params: { companyId } });
    }
    async CheckBlockedDays(BookPropertiesModel) {
        return await api.post(`ManageAsset/CheckBlockedDays`, BookPropertiesModel);
    }
    async SellOwnedAsset(SellModel) {
        return api.post('ManageAsset/SellOwnedAsset', SellModel);
    }
    async getdoumenttypelist(compnyId) {

        let masterNames = 'DOCUMENTTYPE';
        let masterKeyText = 'DOCUMENTTYPE';
        //let userId = localStorage.getItem('userId');
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${compnyId}`);
    }

    async EditContactUser(EditContactUserModel) {
        return await api.post(`ManageAsset/EditContactUser`, EditContactUserModel);
    }
    async GetUser(id) {
        return await api.get(`ManageAsset/GetUser/${id}`);
    }
    async Addclientfeedback(model) {
        return await api.post(`ManageAsset/AddMeetingReview`, model);
    }

    async TicketStatus(id, status, userId, companyId) {
        return await api.get(`ManageTicket/TicketStatus/${id}/${status}/${userId}/${companyId}`)
    }
    async getTicketListing(obj) {
        return await api.post(`ManageTicket/GetTicketList`, obj);
    };
    async deleteTicket(obj) {
        return await api.post(`ManageTicket/DeleteTicket`, obj);
    };

    async addEditTicket(dataModel) {
        return await api.post(`ManageTicket/AddEditTicket`, dataModel);
    };
    async assignvendor(jsonmodel) {
        return await api.post(`ManageTicket/assignticket`, jsonmodel);
    };
    async AddTicketInvoice(jsonmodel) {
        return await api.post(`ManageTicket/AddTicketInvoicePayment`, jsonmodel);
    };

    async assignvendorList(ticketId, searchItem, sortColumn, sortDir, pageIndex, pageSize, userId, companyId, refCode) {       
        return await api.get(`ManageTicket/AssignTicketVednorList/${ticketId}/${searchItem}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${userId}/${companyId}/${refCode}`,);
    };
    async addEditTicket(model) {
        return await api.post(`ManageTicket/AddEditTicket`, model);
    };
    async AddressInfo(JsonAddressData, CompanyId, UserId) {
        return await api.post(`ManageTicket/AddressInformation/${CompanyId}/${UserId}`, JsonAddressData);
    }

    async GetContactUserList(searchModel) {
        return await api.post(`ManageContacts/GetContactUserList`, searchModel);
    }
    async GetContactUserById(id) {
        return await api.get(`ManageContacts/GetContactUserById/${id}`);
    }
    async ChangedClientStatusById(userId, status) {
        return await api.get(`ManageContacts/ChangedClientStatusById/${userId}/${status}`)
    }

    async DeleteContactUserById(id, userId, companyId,ipAddress) {
        return await api.get(`ManageContacts/DeleteContactUserById/${id}/${userId}/${companyId}/${ipAddress}`);
    }
    async ExportData(records, type, filename, pageLength = "") {
        if (type == 'Excel') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".xlsx")
            })
        }
        else if (type == 'CSV') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".csv")

            })
        }
        else if (type == 'PDF') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".pdf")
            })
        }

    }
    async ImportContatcFromExcel(importModel) {
        return await api.post(`ManageContacts/SaveBulkUpload`, importModel);
    }
    async addeditDocument(Documentdata) {
        return await api.post(`ManageDocument/AddDcoument`, Documentdata, {
            "Content-Type": "multipart/form-data"
        });
    }

    async getDocumentList(search, userid, sortby, orderby, pageindex, pagesize) {
        return await api.get(`ManageDocument/GetDocumentDetail/${search}/${userid}/${sortby}/${orderby}/${pageindex}/${pagesize}`);
    }
    async getTicketCustomFieldsData(primaryKey, moduleCode, subModuleCode, otherData, refId, displayCode, companyId, userId, isFor, deviceType,
        layoutType, bookingAssetId, bookingId, ViewBookingFlag) {

        return await api.get(`ManageTicket/GetCustomFieldsData/${primaryKey}/${moduleCode}/${subModuleCode}/${otherData}/${refId}/${displayCode}/${companyId}/${userId}/${isFor}
            /${deviceType}/${layoutType}/${bookingAssetId}/${bookingId}/${ViewBookingFlag}`);
    }

    async DeleteDocumentDetailById(id,companyId,userId,ipAddress) {//14-06-23
        //let userId = localStorage.getItem('userId')
        return await api.post(`ManageDocument/DeleteDocumentDetailById/${id}/${companyId}/${userId}/${ipAddress}`);
    }
    async ChangedDocumentStatusById(userId, status) {
        return await api.get(`ManageDocument/ChangedDocumentStatusById/${userId}/${status}`)
    }
    async GetDocumentDetailsById(id) {
        
       return await api.get(`ManageDocument/GetDocumentDetailsbyId/${id}`)
    }
    async GetAssignedTicketList(searchModel) {
        if (localStorage.getItem('userType') == 'usertype12') {
            return await api.post(`ManageTicket/GetAssignedTicketListForAgent`, searchModel);

        } else {
            return await api.post(`ManageTicket/GetAssignedTicketList`, searchModel);
        }
        
    }
    async GetNotificationList(searchModel) {
        if (localStorage.getItem('loginSource')=='Mobile') {
            searchModel.pageSize = 1000;
        }
        return api.post('ManageNotification/GetNotificationList', searchModel);
    }
    async ChangeNotificationStatusById(userId, status) {
        return await api.get(`ManageNotification/ChangeNotificationStatusById/${userId}/${status}`)
    }
    async UpdateAssignedTicketStatus(data) {
        return await api.post(`ManageTicket/UpdateAssignedTicketStatus`,data)
    }
    async GetAssignAgentTicketList(searchModel) {
        return await api.post(`ManageTicket/GetAssignedTicketListForAgent`, searchModel);
    }
    async UpdateAssignedTicketStatusByAgent(data) {
        return await api.post(`ManageTicket/UpdateAssignedTicketStatusByAgent`, data);
    }
    async GetEmailAndPhone(UserId, AssetId) {
        return await api.get(`ManageTicket/GetEmailAndPhoneByAssetId/${UserId}/${AssetId}`);
    }
    async GetCurrentWebsiteURL(userId,companyId) {
        return await api.get(`ManageAsset/GetCurrentWebsiteURL/${userId}/${companyId}`);
    }
    async ViewTicketInvoice(companyId, userId, ticketId) {
        return await api.get(`ManageTicket/ViewTicketInvoice/${companyId}/${userId}/${ticketId}`);
    }
    async DownloadTIcketInvoice(companyid, userid,ticketId) {
        return await api.get(`ManageTicket/DownloadTicketInvoicePdf/${companyid}/${userid}/${ticketId}`, { responseType: 'blob' });
    }
    async getTicketViewData(primaryKey, moduleCode, subModuleCode, otherData, refId, displayCode, companyId, userId, isFor, deviceType, layoutType, TicketId) {

        return await api.get(`ManageTicket/GetTicketFieldsData/${primaryKey}/${moduleCode}/${subModuleCode}/${otherData}/${refId}/${displayCode}/${companyId}/${userId}/${isFor}
            /${deviceType}/${layoutType}/${TicketId}`);
    }
    async GetCurrentAssetHolderDetails(assetId, companyId, Shareid) {
        return api.get(`VacationSwapMarketplace/GetCurrentAssetHolderDetails/${assetId}/${companyId}/${Shareid}`);
    }
    async GetRentListAssets(SearchModel) {
        return api.post('ManageAsset/GetRentListAssets', SearchModel);
    }

    async GetBookedDates(model) {
        return await api.post(`Blog/GetBookedDates`, model);
    }
    async GetBookedDatesforAdmin(model) {
        return await api.post(`Blog/GetBookedDatesforAdmin`, model);
    }
    async GetBookingDetails(model) {
        return await api.post(`Blog/GetBookingDetails`, model);
    }
    async SendEmail(id, tranId, companyId, userId) {     
        return await api.get(`manageCompany/GetDataforSendEmail/${id}/${tranId}/${companyId}/${userId}`);
    }
    async GetAssetDetailsForCalendar(companyId,userId,AssetId) {     
        return await api.get(`ManageSiteContact/GetOwnersdetailforCalender/${AssetId}/${companyId}/${userId}`);
    }
    async ChangeVacationSwapStatus(VacationSwapStatusModel) {
        return await api.post(`VacationSwapMarketplace/ChangeVacationSwapRequestsStatus`, VacationSwapStatusModel);
    }
    async GetVacationSwapChatList(assetId, shareId, companyId, requestUserId,userId) {
        return await api.get(`VacationSwapMarketplace/GetVacationSwapChatList/${assetId}/${shareId}/${companyId}/${requestUserId}/${userId}`)
    }
    async SaveVacationSwapChat(vacationSwapChatModal) {
        return await api.post(`VacationSwapMarketplace/SaveVacationSwapChat`, vacationSwapChatModal)
    }

    async GetVacationSwapMarketRequestStatusList(searchModel) {
        debugger;
        return await api.post(`VacationSwapMarketplace/GetVacationSwapMarketplaceRequestStatus`, searchModel);
    }
    async GetAssetShareId(AssetShareIdModel) {
        return await api.post(`VacationSwapMarketplace/GetOwnedAssetShareId`, AssetShareIdModel);
    }
    async GetAssetOwnersDetailsForAdmin(AssetId) {
        return await api.get(`VacationSwapMarketplace/GetAssetOwnersDetailsForAdmin/${AssetId}/`);
    }
    async GetAssetOwnersShareDetails(AssetId, UserId) {
        return await api.get(`VacationSwapMarketplace/GetAssetOwnersSharesDetail/${AssetId}/${UserId}`);
    }
    async GetBookedCheckOutDates(shareid, UserId, CompanyId,AssetId) {
        return await api.get(`VacationSwapMarketplace/GetBookingCheckOutDates/${shareid}/${UserId}/${CompanyId}/${AssetId}`);
    }
    async DownloadFile(docfile,userId,companyId) {
        return await api.get(`ManageDocument/DownloadDocument/${docfile}/${userId}/${companyId}`, { responseType: 'blob' })
    }

    
    async GetAssetBuyDocumentList(SearchModel) {
        const loginSource = localStorage.getItem('loginSource');

        if (loginSource === 'Mobile') {
            SearchModel.pageSize = 1000;
        }
        return await api.post('ManageAsset/GetAssetBuyDocumentList', SearchModel);
    }
    async GetAssetDocumentDetails(assetId, userId, companyId, assetUnitId, bookingId) {
        let url = `ManageAsset/GetAssetDocumentDetails/${assetId}/${userId}/${companyId}`;
        const query = [];
        if (assetUnitId) query.push(`assetUnitId=${assetUnitId}`);
        if (bookingId) query.push(`bookingId=${bookingId}`);
        if (query.length) url += `?${query.join('&')}`;
        return await api.get(url);
    }
    async AssetUploadedDocumentList(searchModel) {
        return await api.post('ManageAsset/AssetUploadedDocumentList', searchModel);
    }
    async GetAssetUploadedDocumentReviewList(searchModel) {
        return await api.post('ManageAsset/AssetUploadedDocumentReviewList', searchModel);
    }
    async SaveAssetDocumentDetails(formdata) {
        return await api.post('ManageAsset/SaveAssetDocumentDetails', formdata, {
            "Content-Type": "multipart/form-data"
        });
    }
    async DeleteUploadDocument(assetId, documentId) {
        return await api.get(`ManageAsset/DeleteAssetDocument/${assetId}/${documentId}`);
    }
    async ChangeUsersDocumentationStatus(StatusModal) {
        return await api.post(`ManagePendingDocuments/ChangeUsersDocumentationStatus`, StatusModal);
    }
    async ImportAgentFromExcel(importModel) {
        return await api.post(`ManageVendor/SaveAgentBulkUpload`, importModel);
    }
    async GetAdvanceBookingDetail(assetId, userId, assetUnitId, bookingId) {
        let url = `ManageAsset/GetAdvanceBookingDetail/${assetId}/${userId}`;
        const query = [];
        if (assetUnitId) query.push(`assetUnitId=${assetUnitId}`);
        if (bookingId) query.push(`bookingId=${bookingId}`);
        if (query.length) url += `?${query.join('&')}`;
        return await api.get(url);
    }
    async GetAssetDetails(companyId,userId,AssetId) {
        return await api.get(`ManageSiteContact/GetOwnersdetailforCalender/${AssetId}/${companyId}/${userId}`);
    }
    async GetAssetCancellationPolicy(assetId, companyId, userId) {
        return await api.get(`ManageAsset/GetAssetCancellationPolicy/${assetId}/${companyId}/${userId}`);
    }
    async CancellationPolicyCharges(assetId,companyId, userId) {
        return await api.get(`ManageAsset/CancellationPolicyCharges/${assetId}/${companyId}/${userId}`);
    }
    async ReasonAssetCancellation(assetCancelBooking) {
        return await api.post(`ManageAsset/CancelAssetBooking`, assetCancelBooking);
    }
    async UploadESignDocument(formData) {
        return await api.post('ManageAsset/UploadESignDocument', formData, {
            "Content-Type": "multipart/form-data"
        });
    };
    async GetESignDocumentList(searchModel) {
        return await api.post(`ManageAsset/GetESignDocumentList`, searchModel);
    }
    async AssetListDropdown(companyId) {
        return await api.get(`ManageAsset/AssetListDropdown/${companyId}`);
    }
    async ESignDocumentList(searchModel) {
        return await api.post(`ManageESignedDocument/ESignDocumentList`, searchModel);
    }
    async DownloadAssetDocument(fileName, userIdFromCaller) {
        const userId = userIdFromCaller || localStorage.getItem('userId');
        return await api.get(`ManageAsset/DownloadAssetDocument/${fileName}/${userId}`, { responseType: 'blob' })
    }
    async DeleteESignDocument(Id, ipaddress,companyId,userId) {
        return await api.get(`ManageAsset/DeleteESignDocument/${Id}/${ipaddress}/${companyId}/${userId}`);
    }
    async StatusChangesESignDocument(Id, Status) {
        return await api.get(`ManageAsset/StatusChangesESignDocument/${Id}/${Status}`);
    }
    async GetESignedDocumentListByAdmin(searchModel) {
        return await api.post(`ManageESignedDocument/GetESignedDocumentListByAdmin`, searchModel);
    }
    async GenerateESignDocument(docMapId, assetId, buyerUserId, companyId, minimumSharePriceamt, shareNumber) {
        return await api.get(`ManageESignedDocument/GenerateESignDocument/${docMapId}/${assetId}/${buyerUserId}/${companyId}/${minimumSharePriceamt}/${shareNumber}`);
    }
    async GenerateESignedDocumentLink(esignedFields) {
        return await api.post(`ManageESignedDocument/GenerateFinalESignedDocument`, esignedFields);
    }
    async ViewGeneratedDocument(fileName, isGenerated, isSigned, userId, companyId) {
        return api.get(`ManageESignedDocument/ViewGeneratedDocument/${fileName}/${isGenerated}/${isSigned}/${userId}/${companyId}`);
    }
    async DownloadESignDocument(fileName, IsSigned) {
        return api.get(`ManageESignedDocument/DownloadESignDocument/${fileName}/${IsSigned}`);
    }
    GetAssetDetail(assetId, userId, ipAddress) {
        return api.get(`ManageAsset/GetAssetDetail/${assetId}/${userId}/${ipAddress}`);
    }
    async AddMinimumAmountPaymentDetailsProperty(PayementDetails) {
        return await api.post(`ManageAsset/AddMinimumPaymentDetails`, PayementDetails);
    }
    async AddPaymentDetailsProperty(PayementDetails) {
        return await api.post(`ManageAsset/AddPaymentDetails`, PayementDetails);
    }
    async AddPaymentDetailsWireProperty(model) {
        return await api.post(`ManageAsset/AddPaymentDetailsWithWire`, model);
    }
    async AddInterestCompanyProperty(interestCompProperty) {
        return await api.post(`ManageAsset/AddInterestCompanyProperty`, interestCompProperty);
    }
    async getassetsharehistory(searchModel, assetId,fromdate,todate) {
        
        return await api.post(`ManageAsset/GetAssetssharehistory/${assetId}/${fromdate}/${todate}`, searchModel)
    }
    async UpdateShareAssignmentStatus(shareHistoryId, isAssigned, assetId, companyId, updatedBy) {
        return await api.get(`ManageAsset/UpdateShareAssignmentStatus/${shareHistoryId}/${isAssigned}/${assetId}/${companyId}/${updatedBy}`);
    }
    async GetShareholderDependencies(shareHolderId, assetId, companyId) {
        return await api.get(`ManageAsset/GetShareholderDependencies/${shareHolderId}/${assetId}/${companyId}`);
    }
    async UpdateAssetSubmitRequest(searchModel) {

        return await api.post(`ManageAsset/UpdateAssetSubmitRequest`, searchModel)
    }
    async GetAssetSubmitRequest(userId, companyId,assetId) {
        return api.get(`ManageAsset/GetAssetSubmitRequest/${assetId}/${userId}/${companyId}`);
    }
    async getCalendarViewTicketListing(obj) {
        var userId = localStorage.getItem('userId');
        return await api.get(`ManageTicket/GetcalendarViewticketlist/${obj.COMPANY_ID}/${userId}`);
    };
    async GetBookingId(objmodel) {
        return await api.post(`Blog/GetBookingId`, objmodel);
    }
    async getassettokenhistory(searchModel, assetId, fromdate, todate) {

        return await api.post(`ManageAsset/GetTokensDetailById/${assetId}/${fromdate}/${todate}`, searchModel)
    }
    async getassetmytokenlist(searchModel) {

        return await api.post(`ManageAsset/GetMyTokensList`, searchModel);
    }
    async UpdateCompanyUsersToken(userProfile) {
        debugger;
        return await api.post(`UserProfile/UpdateCompanyUsersToken`, userProfile);
    }
    SaveChatMessage(model) {
        return api.post(`/Expense/SaveMessage`, model);
    }
    GetChatHistory(userId, companyId, sessionId, pairCount = 3) {
        return api.get(`/Expense/GetHistory`, {
            params: { userId, companyId, sessionId, pairCount }
        });
    }
    async GetTicketAllHistory(ticketId, companyId) {
        debugger;
        return await api.get(
            `ManageTicket/GetTicketAllHistory/${ticketId}/${companyId}`
        );
    }
    async GetTicketDetail(ticketId) {
        const companyId = localStorage.getItem('companyId') || '';
        const userId = localStorage.getItem('userId') || '';
        return await api.get(`ManageTicket/GetTicketDetail/${ticketId}`, {
            params: { companyId, userId }
        });
    }
    async downloadAssetInvoiceV2(companyid, userid, AssetId, InvoiceNumber) {
        debugger;
        return await api.get(
            `AssetInvoice/AssetInvoicePdfV2/${companyid}/${userid}/${AssetId}/${InvoiceNumber}`
          
        );
    }
    async getAssetBuyDetail(companyid, userid, AssetId) {
        return await api.get(`AssetInvoice/GetAssetBuyDetail/${companyid}/${userid}/${AssetId}`);
    }
    async DownloadUploadedFile(fileName, userId) {
        return api.get(`ManageESignedDocument/DownloadUploadedDocument/${fileName}/${userId}`);
    }
    async UpdateEbookDownloadStatus(model) {
        debugger;
        return await api.post(`ManageSubscribers/UpdateEbookDownloadStatus`, model, { responseType: 'blob' });
    }
    async GetEbookList(model) {
        return await api.post(`ManageSubscribers/GetEbookList`, model);
    }
    async GetFreeTrialLeadList(model) {
        return await api.post(`ManageSubscribers/GetFreeTrialLeadList`, model);
    }
    async DeleteEbookSubscriber(id, UserId, CompanyId, IPAddress) {
        return await api.post(`ManageSubscribers/DeleteEbookSubscriber`, {
            Id: id,
            UserId: UserId,
            CompanyId: CompanyId,
            IPAddress: IPAddress
        });
    }
    async DeleteFreeTrialLead(id, UserId, CompanyId, IPAddress) {
        return await api.post(`ManageSubscribers/DeleteFreeTrialLead`, {
            Id: id,
            UserId: UserId,
            CompanyId: CompanyId,
            IPAddress: IPAddress
        });
    }
    async CheckVendorAvailability(model) {
        return await api.post(`ManageTicket/CheckVendorAvailability`,model)
    }
}
 
export default new CompanyUserService();

